import { Component } from '@angular/core';

@Component({
  selector: 'app-readings-layout',
  template: `<router-outlet></router-outlet>`,
})
export class ReadingsLayoutComponent {}
